import { Injectable } from "@angular/core";
import { AuthServiceBackend } from "@serviceBackends";
import { AuthDTO } from "@DTOS";
import { Router } from "@angular/router";
import { GrupoEnum } from "@shared/enums";
import { Nilable } from "@shared/utils";
import { firstValueFrom, Observable, Subject } from "rxjs";
import { Store } from "@ngxs/store";
import { GlobalAcciones } from "@shared/states";

@Injectable({
    providedIn: "root"
})
export class AuthService {
    public token: Nilable<string>;
    public grupo: Nilable<GrupoEnum>;
    public clienteId: Nilable<number>;
    public logout$: Observable<void>;

    private _logout$ = new Subject<void>();

    constructor(protected authServiceBackend: AuthServiceBackend, private router: Router, private store: Store) {
        this.token = localStorage.getItem("token");
        const grupo = localStorage.getItem("grupo");
        this.logout$ = this._logout$.asObservable();

        if (grupo != null) {
            this.grupo = GrupoEnum[grupo];
        }
    }

    public async login(authDTO: AuthDTO): Promise<boolean> {
        localStorage.removeItem("token");
        localStorage.removeItem("grupo");
        this.token = null;

        try {
            const resAuth = await firstValueFrom(this.authServiceBackend.login(authDTO));
            if (resAuth != null && resAuth.token != null) {
                this.token = resAuth.token;
                this.grupo = resAuth.grupo;
                this.clienteId = resAuth.cliente.id;

                localStorage.setItem("token", this.token);
                localStorage.setItem("grupo", this.grupo.toString());

                return true;
            }

            return false;
        } catch (ex) {
            return false;
        }
    }

    public async salir(): Promise<void> {
        localStorage.removeItem("token");
        localStorage.removeItem("grupo");
        this.token = null;
        this._logout$.next();
        this.store.dispatch(new GlobalAcciones.Salir());
        await this.router.navigate(["/login"]);
    }
}
